import api from "../assets/images/api.png";
import git from "../assets/images/git.png";
import javascript from "../assets/images/javascript.png";
import node from "../assets/images/node.png";
import python from "../assets/images/python.png";
import typeScript from "../assets/images/typeScript.svg";
import scikit_learn from "../assets/images/scikit_learn.png";
import react from "../assets/images/react.png";
import redux from "../assets/images/redux.png";
import sass from "../assets/images/sass.png";
import typescript from "../assets/images/typescript.png";
import vue from "../assets/images/vue.png";
import django from "../assets/images/django.svg";
import nestjs from "../assets/images/nestjs.svg";
import docker from "../assets/images/docker.svg";
import kubernetes from "../assets/images/kubernetes.svg";
import express from "../assets/images/express.svg";
import github from "../assets/images/github.svg";
import githubactions from "../assets/images/githubactions.svg";
import java from "../assets/images/java.png";
import mongodb from "../assets/images/mongoDB.svg";
import mongodbatlas from "../assets/images/mongodbatlas.png";
import numpy from "../assets/images/numpy.png";
import pandas from "../assets/images/pandas.png";
import postman from "../assets/images/postman.svg";
import pytorch from "../assets/images/pytorch.png";
import solidity from "../assets/images/solidity.png";
import unity from "../assets/images/unity.svg";
import csharp from "../assets/images/csharp.svg";
import androidstudio from "../assets/images/androidstudio.png";
import firebase from "../assets/images/firebase.svg";
import hardhat from "../assets/images/hardhat.png";
import mocha from "../assets/images/mocha.png";
import chai from "../assets/images/chai.png";
import ether from "../assets/images/ether.png";
import bdrive from "../assets/images/bdrive.png";

import defaultImg from "../assets/images/defaultImg.png";

import circle from "../assets/images/circle.svg";

import fastapi from "../assets/images/fastapi.png";
import websockets from "../assets/images/websockets.png";
import redis from "../assets/images/redis.png";
import postgres from "../assets/images/postgres.svg";
import postgis from "../assets/images/postgis.png";
import nextjs from "../assets/images/nextjs.png";
import gcp from "../assets/images/gcp.png";
import huggingface from "../assets/images/huggingface.png";
import opencv from "../assets/images/opencv.png";
import mapbox from "../assets/images/mapbox.png";

import webdeveloper from "../assets/images/web_dev.jpg";
import machinelearning from "../assets/images/ml.jpg";
import blockchain from "../assets/images/blockchain.jpg";
import gamedeveloper from "../assets/images/game_dev.jpg";

import minilondon3d from "../assets/images/minilondon3d.jpg";
import searchlight from "../assets/images/searchlight.jpg";
import talkmate from "../assets/images/talkmate.jpg";
import docuwatch from "../assets/images/docuwatch.jpg";
import travelguide3d from "../assets/images/travelguide3d.jpg";
import spheron from "../assets/images/spheron.png";
import ninjesk from "../assets/images/ninjesk.png";
import hyperface from "../assets/images/hyperface.jpg";
import portfolio from "../assets/images/portfolio.png";
import instagram from "../assets/images/instagram.png";

import itsuk_award from "../assets/images/itsuk_award.jpg";

const images = {
  api,
  git,
  javascript,
  node,
  python,
  typeScript,
  react,
  redux,
  sass,
  typescript,
  vue,
  django,
  nestjs,
  docker,
  kubernetes,
  express,
  github,
  githubactions,
  java,
  mongodb,
  mongodbatlas,
  numpy,
  pandas,
  postman,
  pytorch,
  scikit_learn,
  solidity,
  unity,
  csharp,
  androidstudio,
  firebase,
  hardhat,
  mocha,
  chai,
  ether,
  bdrive,

  defaultImg,
  circle,

  nextjs,
  huggingface,
  redis,
  postgres,
  postgis,
  fastapi,
  websockets,
  gcp,
  opencv,
  mapbox,

  webdeveloper,
  machinelearning,
  blockchain,
  gamedeveloper,

  minilondon3d,
  searchlight,
  talkmate,
  docuwatch,
  travelguide3d,
  spheron,
  ninjesk,
  hyperface,
  portfolio,
  instagram,

  itsuk_award,
};

export default images;
